<template>
	<fragment v-if="member_ && authList.length > 0">
		<div class="container-fiuld clearfix">
			<div class="btn-group-box m-b-15 clearfix">
				<div class="btn-group pull-left clearfix">
					<!-- <div class="select pull-left m-r-5">
						<a class="btn round"  @click="$emit('onEmail')">
							<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="22" height="20"
								viewBox="0 0 22 20">
								<path class="msg-i"
									d="M262.519,1266.28a0.158,0.158,0,0,0,.019.08c0,0.02.019,0.06,0.019,0.08a0.473,0.473,0,0,1,.019.08,0.3,0.3,0,0,1,.038.08c0.019,0.02.019,0.04,0.038,0.06a0.107,0.107,0,0,1,.038.06l0.057,0.06,0.019,0.02a0.019,0.019,0,0,1,.019.02,0.447,0.447,0,0,0,.209.12,0.037,0.037,0,0,1,.038.02,0.91,0.91,0,0,0,.228.04h20.5a0.91,0.91,0,0,0,.228-0.04,0.037,0.037,0,0,0,.038-0.02,2.043,2.043,0,0,0,.209-0.12,0.019,0.019,0,0,0,.019-0.02l0.019-.02,0.057-.06a0.107,0.107,0,0,0,.038-0.06c0.019-.02.019-0.04,0.038-0.06a0.3,0.3,0,0,0,.038-0.08,0.1,0.1,0,0,0,.019-0.08c0-.02.019-0.06,0.019-0.08a0.473,0.473,0,0,0,.019-0.08v-18.46a0.792,0.792,0,0,0-.779-0.82H263.279a0.792,0.792,0,0,0-.779.82v18.38A0.1,0.1,0,0,1,262.519,1266.28Zm2.432-.94,5.756-7.25,2.394,1.76a0.752,0.752,0,0,0,.874,0l2.394-1.76,5.756,7.25H264.951Zm18.067-1.44-5.377-6.75,5.358-3.94v10.69h0.019Zm-18.96-15.26H283v2.58l-9.461,6.95-9.48-6.95v-2.58Zm0,4.57,5.357,3.94-5.357,6.75v-10.69Z"
									transform="translate(-262.5 -1247)" />
							</svg> 전자우편 보내기
						</a>
					</div> -->
					<div class="select pull-left m-r-5">
						<a class="btn round" @click="$emit('onSms')">
							<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="20" height="20"
								viewBox="0 0 20 20">
								<path class="sms-i"
									d="M386.428,1249.93a10,10,0,0,1,14.807,13.41,3.719,3.719,0,0,0,1.575,1.82,0.933,0.933,0,0,1-.268,1.76,5.3,5.3,0,0,1-.708.05h0a6.478,6.478,0,0,1-3.6-1.16A10,10,0,0,1,386.428,1249.93Zm0.8,13.34a8.909,8.909,0,0,0,10.763,1.38,0.59,0.59,0,0,1,.285-0.08,0.621,0.621,0,0,1,.348.11,5.414,5.414,0,0,0,3.138,1.16,5.789,5.789,0,0,1-1.714-2.37,0.561,0.561,0,0,1,.1-0.6A8.871,8.871,0,1,0,387.229,1263.27Zm2.082-9.57h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1253.7Zm0,2.73h8.38a0.569,0.569,0,0,1,.565.57,0.561,0.561,0,0,1-.565.56h-8.38a0.562,0.562,0,0,1-.566-0.56A0.573,0.573,0,0,1,389.311,1256.43Zm0,2.74h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1259.17Z"
									transform="translate(-383.5 -1247)" />
							</svg> 문자 보내기
						</a>
					</div>
					<div class="select pull-left m-r-5">
						<a class="btn btn-red round" @click="deleteMemberData()">
							<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="17" height="20" viewBox="0 0 17 20">
								<path class="recycle"
									d="M510.213,1255.71h1.574v8.16h-1.574v-8.16Zm3.148,0h1.574v8.16h-1.574v-8.16Zm-6.3,0h1.574v8.16h-1.574v-8.16Zm10.074-5.86h-2.4v-0.51a2.353,2.353,0,0,0-2.361-2.34h-2.755a2.354,2.354,0,0,0-2.361,2.34v0.51h-2.4a2.353,2.353,0,0,0-2.361,2.34v1.96h1.574v10.51a2.353,2.353,0,0,0,2.361,2.34h9.13a2.353,2.353,0,0,0,2.361-2.34v-10.51H519.5v-1.96A2.353,2.353,0,0,0,517.139,1249.85Zm-8.3-.51a0.784,0.784,0,0,1,.787-0.78h2.755a0.784,0.784,0,0,1,.787.78v0.51h-4.329v-0.51Zm7.517,15.32a0.784,0.784,0,0,1-.787.78h-9.13a0.784,0.784,0,0,1-.787-0.78v-10.51h10.7v10.51Zm1.574-12.07H504.074v-0.4a0.784,0.784,0,0,1,.787-0.78h12.278a0.784,0.784,0,0,1,.787.78v0.4Z"
									transform="translate(-502.5 -1247)" />
							</svg> 탈퇴처리
						</a>
					</div>
				</div>

				<div class="btn-group pull-right clearfix">
					<div class="select pull-left">
						<a class="btn round pull-left" @click="updateMember">
							완료
						</a>
					</div>
				</div>
			</div>

			<p class="f-18 text-darkgray m-b-10">기본정보</p>
			<div class="col-md-6 p-l-0">
				<div class="round m-b-10">
					<div class="input-group full-width">
						<span class="input-group-addon label not bg-blue v-mid text-white">
							이름
						</span>
						<input class="form-control full-width b-l-0" type="text" placeholder="이름" v-model="member_.mberName">
					</div>
				</div>
				<div class="round m-b-10">
					<div class="input-group full-width">
						<span class="input-group-addon label not bg-blue v-mid text-white">
							아이디
						</span>
						<input class="form-control full-width b-l-0" type="text" placeholder="아이디" v-model="member_.mberId" disabled>
					</div>
				</div>
				<div class="round m-b-10">
					<div class="input-group full-width">
						<span class="input-group-addon label not bg-blue v-mid text-white">
							비밀번호 수정
						</span>
						<input class="form-control full-width b-l-0" type="password" v-model="member_.password" placeholder="변경시에만 입력하세요">
						<span class="input-group-addon button v-mid" style="width: 84px;">
							<button class="btn round" type="button" @click="resetPassword()">임시발급</button>
						</span>
					</div>
				</div>
				<div class="round m-b-10">
					<div class="input-group full-width">
						<span class="input-group-addon label not bg-blue v-mid text-white">
							휴대전화
						</span>
						<input class="form-control full-width round b-l-0" type="text" placeholder="전화번호" v-model="member_.mobileNum">
						<span class="input-group-addon v-mid p-l-5" style="width:120px">
							<select class="form-control full-width round" v-model="member_.mobileRecvEnable">
								<option disabled></option>
								<option :value="0">수신미허용</option>
								<option :value="1">수신허용</option>
							</select>
						</span>
					</div>
				</div>
				<div class="round m-b-10">
					<div class="input-group full-width">
						<span class="input-group-addon label not bg-blue v-mid text-white">
							전자우편
						</span>
						<input class="form-control full-width round" type="text" placeholder="이메일" v-model="member_.email">
						<span class="input-group-addon v-mid p-l-5" style="width:120px">
							<select class="form-control full-width round" v-model="member_.emailRecvEnable">
								<option disabled></option>
								<option :value="0">수신미허용</option>
								<option :value="1">수신허용</option>
							</select>
						</span>
					</div>
				</div>
			</div>

			<div class="col-md-6 p-r-0">
				<!-- <div class="round m-b-10">
					<div class="input-group full-width">
						<span class="input-group-addon label not bg-blue v-mid text-white">
							직업
						</span>
						<select class="form-control full-width" v-model="member_.workCode" @change="setJobQuestions($event)">
							<option :value="undefined">===직업을 선택해주세요.===</option>
							<option v-for="job in jobs" :key="hash(job)" :value="job.code">{{job.codeNm}}</option>
						</select>
					</div>
				</div> -->

				<div class="round m-b-10" v-for="question in jobQuestions_" :key="`workinfo-${hash(question)}`">
					<div class="input-group full-width">
						<span class="input-group-addon label not bg-blue v-mid text-white">
							{{question.workInfoName}}
						</span>

						<select class="form-control full-width full-width b-l-0" :value="getJobAnswer(question.workInfoName)" @change="setJobAnswer($event, question)" v-if="question.type == 'select'">
							<option value="">{{question.workInfoName}}</option>
							<option v-for="option in question.option.split('/')" :key="`job-question-${hash(question)}-option-${option}`" :value="option">{{option}}</option>
						</select>

						<input class="form-control full-width b-l-0" type="text" :placeholder="question.workInfoName" :value="getJobAnswer(question.workInfoName)" @change="setJobAnswer($event, question)" v-if="question.type == 'text'">
					</div>
				</div>
			</div>

			<div class="clearfix"></div>

			<!-- <p class="f-18 text-darkgray m-b-5 m-t-30">강사권한 관리</p>
			<div class="input-group w200">
				<span class="input-group-addon v-mid clearfix">
					<div class="checkbox">
						<input id="chek1" type="radio" name="check1" :checked="member_.instEnable" @click="member_.instEnable=true">
						<label for="chek1" class="s-lineH round-left">사용</label>
					</div>
					<div class="checkbox">
						<input id="chek2" type="radio" name="check1" :checked="!member_.instEnable"  @click="member_.instEnable=false">
						<label for="chek2" class="s-lineH round-right">미사용</label>
					</div>
				</span>
			</div>
			<template v-if="member_.instEnable">
				<div class="round m-b-30">
					<div class="input-group full-width">
						<span class="input-group-addon w160 v-mid text-white p-r-5">
							<select class="form-control full-width round"
								@change="addAuthAllotList" v-model="authSelected">
								<option value="">권한선택</option>
								<option v-for="(auth, idx) in authList.filter(el=>el.type==='강사')"
									:key="`auth-item-${hash(auth)}-${idx}`" :value="auth.authId">
									{{auth.authName}}
								</option>
							</select>
						</span>
						<span class="input-group-addon v-mid text-white">
							<div class="round on-border bg-white auth-info">
								<div class="input-group p-5">
									<span class="input-group-addon"
										v-for="(auth, idx) in member_.authAllotList.filter(e=> getAuth(e.authId) && getAuth(e.authId).type ==='강사')"
										:key="`auth-allot-list-${hash(auth)}-${idx}`">
										{{getAuth(auth.authId).authName}}
										<a class="m-r-5 text-blue text-bold" @click="removeAuthId(authId)">&times;</a>
									</span>
								</div>
							</div>
						</span>
					</div>
				</div>
				<div class="col-md-6 p-l-0">
					<div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label not bg-blue v-mid text-white">
								지역국어원
							</span>
							<input class="form-control full-width b-l-0" type="text" placeholder="지역국어원" v-model="localKorInst">
						</div>
					</div>
				</div>
				<div class="col-md-6 p-r-0">
					<div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label not bg-blue v-mid text-white">
								은행명
							</span>
							<input class="form-control full-width b-l-0" type="text" placeholder="은행명" v-model="bankName">
						</div>
					</div>
				</div>

				<div class="col-md-6 p-l-0">
					<div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label not bg-blue v-mid text-white">
								예금주
							</span>
							<input class="form-control full-width b-l-0" type="text" v-model="depositor" placeholder="예금주">
						</div>
					</div>
				</div>
				<div class="col-md-6 p-r-0">
					<div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label not bg-blue v-mid text-white"> 계좌번호 </span>
							<input class="form-control full-width b-l-0" type="text" placeholder="계좌번호"  v-model="accountInfo">
						</div>
					</div>
				</div>

				<div class="col-md-12 p-l-0 p-r-0">
					<div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label not bg-blue v-mid text-white">
								이력서
							</span>
							<input class="form-control full-width b-l-0" type="file" placeholder="이력서" ref="refCarrer" @change="changeUploadFile" multiple>
						</div>
					</div>
				</div>

				<div class="col-md-12 p-l-0 p-r-0">
					<div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label not bg-blue v-mid text-white">
								약력
							</span>
							<input class="form-control full-width b-l-0" type="text" placeholder="약력" v-model="career">
						</div>
					</div>
				</div>

				<div class="clearfix"></div>
			</template> -->


			<p class="f-18 text-darkgray m-b-5 m-t-15">관리자권한 관리</p>
			<div class="input-group w200">
				<span class="input-group-addon v-mid clearfix">
					<div class="checkbox">
						<input id="chek3" type="radio" name="check2" :checked="member_.adminEnable" @click="member_.adminEnable=true">
						<label for="chek3" class="s-lineH round-left">사용</label>
					</div>
					<div class="checkbox">
						<input id="chek4" type="radio" name="check2"  :checked="!member_.adminEnable"  @click="member_.adminEnable=false">
						<label for="chek4" class="s-lineH round-right">미사용</label>
					</div>
				</span>
			</div>
			<div class="round m-b-30" v-if="member_.adminEnable">
				<div class="input-group full-width">
					<span class="input-group-addon w160 v-mid text-white p-r-5">
						<select class="form-control full-width round"
							@change="addAuthAllotList" v-model="authSelected">
							<option value="">권한선택</option>
							<option v-for="(auth, idx) in authList.filter(el=>el.type==='관리자')"
								:key="`auth-item-${hash(auth)}-${idx}`" :value="auth.authId">
								{{auth.authName}}
							</option>
						</select>
					</span>
					<span class="input-group-addon v-mid text-white">
						<div class="round on-border bg-white auth-info">
							<div class="input-group p-5">
								<span class="input-group-addon"
									v-for="(auth, idx) in member_.authAllotList.filter(e=>getAuth(e.authId).type ==='관리자')"
									:key="`auth-allot-list-${hash(auth)}-${idx}`">
									{{getAuth(auth.authId).authName}}
									<a class="m-r-5 text-blue text-bold" @click="removeAuthId(authId)">&times;</a>
								</span>
							</div>
						</div>
					</span>
				</div>
			</div>
		</div>

		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>
	</fragment>
</template>

<script>
import axios from 'axios'
import server from '../../statics/server'
import ModalConfirm from '../../modals/ModalConfirm.vue'
import ModalAlert from '../../modals/ModalAlert.vue'

import fnGetJobData from '../../mixins/fnGetJobData'

export default {
	name: "SubviewUserDetailModify",
	mounted: function() {
	},
	mixins: [fnGetJobData],
	data: function() {
		let localKorInst = "", bankName = "", depositor = "", accountInfo = "", career = "";
		if(this.member.instInfoList.length) {
			localKorInst = this.member.instInfoList[0].localKorInst;
			bankName = this.member.instInfoList[0].bankName;
			depositor = this.member.instInfoList[0].depositor;
			accountInfo = this.member.instInfoList[0].accountInfo;
			career = this.member.instInfoList[0].career;
		}

		return {
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default(),
			},
			member_: {...JSON.parse(JSON.stringify(this.member)), password:""},
			jobQuestions_: JSON.parse(JSON.stringify(this.jobQuestions)),
			authSelected: "",
			uploadFile: false,
			// user input
			localKorInst, bankName, depositor, accountInfo, career
		}
	},
	components: {
		ModalConfirm, ModalAlert
	},
	props: {
		member: Object,
		jobQuestions: Array,
		authList: Array
	},
	methods: {
		// 유저 직업정보 변경
		setJobQuestions: async function($event) {
			const { value } = $event.target;

			try {
				const { data } = await axios.post(`${server.addr()}${server.api.WORK_INFO}`, { workCode: value });
				this.jobQuestions_ = data.list;
				this.member_.workInfoList = [];
			} catch (e) {
				// DOTO: error exception
			}
		},
		// 유저 삭제
		deleteMemberData: function() {
			this.modals.ModalConfirm.msg = "선택한 회원을 탈퇴처리 하시겠습니까?";
			this.modals.ModalConfirm.show = true;

			this.modals.ModalConfirm.btnYes.fn = async () => {
				try {
					await axios.delete(`${server.addr()}${server.api.MBER}/${this.member.mberId}`);

					this.$router.push("/users");
				} catch(e) {
					this.modals.ModalAlert.msg = "통신에러! 잠시 후 다시 시도해주세요.";
					this.modals.ModalAlert.show = true;
				}
				this.modals.ModalConfirm.show = false;
			}
		},
		// 업데이트
		updateMember: async function() {
			if(this.uploadFile) {
				this.modals.ModalAlert.msg = "파일을 업로드 중입니다. 잠시 후 다시 시도해주세요.";
				this.modals.ModalAlert.show = true;
				return;
			}
			try {
				const {
					mberName, zipcode, addr, detailAddr, phoneNum, mobileNum, faxNum, email,
					sexCode, mobileRecvEnable, emailRecvEnable, instEnable,
					adminEnable, adminAuthList, workInfoList, workCode,
				} = this.member_;
				let { authAllotList } = this.member_;
				if(!authAllotList) authAllotList = [];

				const { localKorInst,bankName,depositor,accountInfo,career } = this;

				const instInfoList = [{ localKorInst,bankName,depositor,accountInfo,career,resumeFile:this.member_.instInfoList[0]['resumeFile']?((typeof this.member_.instInfoList[0]['resumeFile']=="object")?this.member_.instInfoList[0]['resumeFile'].atchFileId:this.member_.instInfoList[0]['resumeFile']):null }];

				authAllotList = authAllotList.filter( e => {
					if(this.getAuth(e.authId).type === "강사" && instEnable) return true;
					if(this.getAuth(e.authId).type === "관리자" && adminEnable) return true;
					return false;
				}).map(e => ({ authId: e.authId }));

				if(this.member_.password) {
					await axios.patch(`${server.addr()}${server.api.MBER}/${this.member.mberId}`, {
						mberName, zipcode, addr, detailAddr, phoneNum, mobileNum, faxNum, email,
						sexCode, mobileRecvEnable, emailRecvEnable, instEnable, instInfoList,
						adminEnable, adminAuthList, workInfoList, workCode, authAllotList, password:this.member_.password
					});
				} else {
					await axios.patch(`${server.addr()}${server.api.MBER}/${this.member.mberId}`, {
						mberName, zipcode, addr, detailAddr, phoneNum, mobileNum, faxNum, email,
						sexCode, mobileRecvEnable, emailRecvEnable, instEnable, instInfoList,
						adminEnable, adminAuthList, workInfoList, workCode, authAllotList
					});
				}

				this.modals.ModalAlert.msg = "성공적으로 변경되었습니다.";
				this.modals.ModalAlert.show = true;
				this.modals.ModalAlert.btn.fn = () => {
					this.$emit("onRefresh", this.member_);
					this.$router.push(`/users/detail/${this.member.mberId}`);
				}
			} catch(e) {
				// eslint-disable-next-line
				console.warn(e);
				this.modals.ModalAlert.msg = "통신에러! 잠시 후 다시 시도해주세요.";
				this.modals.ModalAlert.show = true;
			}

		},
		resetIncorrect: async function() {
			try {
				await axios.patch(`${server.addr()}${server.api.MBER}/${this.member.mberId}`, {
					passwordErrCnt: 0, lockEnable: 0
				});

				this.$emit("onRefresh");
				this.modals.ModalAlert.msg = "초기화되었습니다.";
				this.modals.ModalAlert.show = true;
			} catch(e) {
				this.modals.ModalAlert.msg = "네트워크 오류! 서버 관리자에게 문의해주세요";
				this.modals.ModalAlert.show = true;
			}
		},
		resetPassword: async function() {
			try {
				const { data } = await axios.post(`${server.addr()}${server.api.MBER}/${this.member.mberId}/newPassword`);

				this.modals.ModalAlert.msg = `새로운 비밀번호 : ${data.password}`;
				this.modals.ModalAlert.show = true;
			} catch(e) {
				this.modals.ModalAlert.msg = "네트워크 오류! 서버 관리자에게 문의해주세요";
				this.modals.ModalAlert.show = true;
			}
		},

		// 직업질문 유저 답 얻기
		getJobAnswer: function(itemName) {
			const answer = this.member.workInfoList.find(e=>e.itemName == itemName);
			return answer ? answer.itemValue : "";
		},
		// 직업질문 변경
		setJobAnswer: function($event, question) {
			const { value } = $event.target;

			const answer = this.member_.workInfoList.find(e=>e.itemName == question.workInfoName);

			if(!answer) {
				this.member_.workInfoList.push({
					itemName: question.workInfoName,
					itemValue: value
				});
			} else {
				this.$set(answer, "itemValue", value);
			}
		},
		// 직업 권한 추가
		addAuthAllotList: function(event) {
			const { value } = event.target;
			if(value === "") return;
			this.authSelected = "";

			if(this.member_.authAllotList.find((el) => (el.authId === parseInt(value)))) return;
			this.member_.authAllotList.push(this.getAuth(parseInt(value)));
		},
		// 직업 권한 제거
		removeAuthId: function(authId) {
			const idx = this.member_.authAllotList.findIndex(e=>e===authId);
			this.member_.authAllotList.splice(idx, 1,);
		},

		// authId로 auth 받아오기
		getAuth: function(authId) {
			return this.authList.find(e=> e.authId===authId);
		},

		changeUploadFile: async function() {
			this.uploadFile = true;
			const formData = new FormData();
			formData.append("file", this.$refs.refCarrer.files[0])
			try {
				const { data } = await axios.post(`${server.addr()}/file`, formData, {
					'Content-type': 'multipart/form-data'
				});
				this.member_.instInfoList[0]['resumeFile'] = data;
				this.uploadFile = false;
			} catch(e) {
				this.modals.ModalAlert.msg = "이력서 업로드 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.";
				this.modals.ModalAlert.show = true;
			}
		}
	},
	watch: {
		member: function(val) {
			this.member_ = JSON.parse(JSON.stringify(val));
			if(val.instInfoList.length > 0) {
				this.localKorInst = val.instInfoList[0].localKorInst;
				this.depositor = val.instInfoList[0].depositor;
				this.bankName = val.instInfoList[0].bankName;
				this.career = val.instInfoList[0].career;
				this.accountInfo = val.instInfoList[0].accountInfo;
			}
		},
		jobQuestions: function(val) {
			this.jobQuestions_= JSON.parse(JSON.stringify(val));
		}
	}
}
</script>

<style scoped>
.auth-info {
	height: 40px;
}
.msg-i {
	fill: #999;
	fill-rule: evenodd;
}
.btn-group .btn:hover .msg-i {
	fill: #fff;
	fill-rule: evenodd;
}
.sms-i {
	fill: #999;
	fill-rule: evenodd;
}
.btn-group .btn:hover .sms-i {
	fill: #fff;
	fill-rule: evenodd;
}
.recycle {
	fill: #fff;
	fill-rule: evenodd;
}
.btn-group .btn:hover .recycle {
	fill: #fff;
	fill-rule: evenodd;
}
</style>
